// SAT c_RegimenFiscal and c_UsoCFDI (CFDI 4.0) as published in the JSON catalogs Synapta X reads
// (media.megaservicio.net/public/temp/sat, snapshot 2026-10-19). Person type: f = física (RFC 13), m = moral (RFC 12).
// CP01 (pagos) and CN01 (nómina) are left out: they only apply to CFDI types P and N, never to this sale.
// Keep identical to synapta-secure utils/sat-catalogs.js, which enforces the same rules on /pay.
export const REGIMENES: [string,string,string][] = [
  ['601', 'General de Ley Personas Morales', 'm'],
  ['603', 'Personas Morales con Fines no Lucrativos', 'm'],
  ['605', 'Sueldos y Salarios e Ingresos Asimilados a Salarios', 'f'],
  ['606', 'Arrendamiento', 'f'],
  ['607', 'Régimen de Enajenación o Adquisición de Bienes', 'f'],
  ['608', 'Demás ingresos', 'f'],
  ['610', 'Residentes en el Extranjero sin Establecimiento Permanente en México', 'fm'],
  ['611', 'Ingresos por Dividendos (socios y accionistas)', 'f'],
  ['612', 'Personas Físicas con Actividades Empresariales y Profesionales', 'f'],
  ['614', 'Ingresos por intereses', 'f'],
  ['615', 'Régimen de los ingresos por obtención de premios', 'f'],
  ['616', 'Sin obligaciones fiscales', 'f'],
  ['620', 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos', 'm'],
  ['621', 'Incorporación Fiscal', 'f'],
  ['622', 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras', 'm'],
  ['623', 'Opcional para Grupos de Sociedades', 'm'],
  ['624', 'Coordinados', 'm'],
  ['625', 'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas', 'f'],
  ['626', 'Régimen Simplificado de Confianza', 'fm'],
];
export const USOS: [string,string,string,string][] = [
  ['G01', 'Adquisición de mercancías', 'fm', '601 603 606 612 620 621 622 623 624 625 626'],
  ['G02', 'Devoluciones, descuentos o bonificaciones', 'fm', '601 603 606 612 620 621 622 623 624 625 626'],
  ['G03', 'Gastos en general', 'fm', '601 603 606 612 620 621 622 623 624 625 626'],
  ['I01', 'Construcciones', 'fm', '601 603 606 612 620 621 622 623 624 625 626'],
  ['I02', 'Mobiliario y equipo de oficina por inversiones', 'fm', '601 603 606 612 620 621 622 623 624 625 626'],
  ['I03', 'Equipo de transporte', 'fm', '601 603 606 612 620 621 622 623 624 625 626'],
  ['I04', 'Equipo de computo y accesorios', 'fm', '601 603 606 612 620 621 622 623 624 625 626'],
  ['I05', 'Dados, troqueles, moldes, matrices y herramental', 'fm', '601 603 606 612 620 621 622 623 624 625 626'],
  ['I06', 'Comunicaciones telefónicas', 'fm', '601 603 606 612 620 621 622 623 624 625 626'],
  ['I07', 'Comunicaciones satelitales', 'fm', '601 603 606 612 620 621 622 623 624 625 626'],
  ['I08', 'Otra maquinaria y equipo', 'fm', '601 603 606 612 620 621 622 623 624 625 626'],
  ['D01', 'Honorarios médicos, dentales y gastos hospitalarios', 'f', '605 606 607 608 611 612 614 615 625'],
  ['D02', 'Gastos médicos por incapacidad o discapacidad', 'f', '605 606 607 608 611 612 614 615 625'],
  ['D03', 'Gastos funerales', 'f', '605 606 607 608 611 612 614 615 625'],
  ['D04', 'Donativos', 'f', '605 606 607 608 611 612 614 615 625'],
  ['D05', 'Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)', 'f', '605 606 607 608 611 612 614 615 625'],
  ['D06', 'Aportaciones voluntarias al SAR', 'f', '605 606 607 608 611 612 614 615 625'],
  ['D07', 'Primas por seguros de gastos médicos', 'f', '605 606 607 608 611 612 614 615 625'],
  ['D08', 'Gastos de transportación escolar obligatoria', 'f', '605 606 607 608 611 612 614 615 625'],
  ['D09', 'Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones', 'f', '605 606 607 608 611 612 614 615 625'],
  ['D10', 'Pagos por servicios educativos (colegiaturas)', 'f', '605 606 607 608 611 612 614 615 625'],
  ['S01', 'Sin efectos fiscales', 'fm', '601 603 605 606 607 608 610 611 612 614 615 616 620 621 622 623 624 625 626'],
];
const personType = (rfc:string) => rfc.length === 12 ? 'm' : rfc.length === 13 ? 'f' : '';
export const regimenesFor = (rfc:string) => REGIMENES.filter(([, , type]) => !personType(rfc) || type.includes(personType(rfc)));
export const usosFor = (rfc:string, regimen:string) => USOS.filter(([, , type, regimenes]) => (!personType(rfc) || type.includes(personType(rfc))) && regimenes.split(' ').includes(regimen));
export function fiscalError(rfc:string, regimen:string, uso:string) {
  if (!regimenesFor(rfc).some(([id]) => id === regimen)) return 'BILLING_REGIMEN_INVALID';
  if (!usosFor(rfc, regimen).some(([id]) => id === uso)) return 'BILLING_USO_CFDI_INVALID';
  return null;
}
